import type { ServiceStatus } from '../models/PlaceService.ts';

interface ServiceStatusInfo {
  label: string;
  color: string;
}

const serviceStatusMap: Record<ServiceStatus, ServiceStatusInfo> = {
  ONLINE: { label: '服務中', color: '#12B886' },
  TEMPORARY_OFFLINE: { label: '暫停中', color: '#FAB005' },
  DISABLED: { label: '停止服務', color: '#FA5252' },
};

export const getServiceStatusLabel = (serviceStatus: ServiceStatus) => {
  return serviceStatusMap[serviceStatus]?.label || serviceStatus;
};

export const getServiceStatusColor = (serviceStatus: ServiceStatus) => {
  return serviceStatusMap[serviceStatus]?.color || 'gray';
};
